module.exports = __webpack_public_path__ + "img/quote.f2eeade2.png";